module.exports = __webpack_public_path__ + "static/assets/b78f6f95472f9ea050f8befc2e8c63df.svg";